<template>
  <div class="Broadcasting__wrapper">
    <div class="Broadcasting__body">
      <div class="Broadcasting__body-container">
        <div class="Broadcasting__inner">
          <i class="Broadcasting__icon icon-ic_broadcast"></i>
          <!--<div class="Broadcasting__time">
            {{ duration }}
          </div>-->
          <div class="Broadcasting__status">
            Broadcast is on
          </div>
          <div class="Broadcasting__credentials">
            <div class="Broadcasting__credentials-item">
              <i class="icon-ic_link Broadcasting__credentials-icon-link"></i>
              {{user.conferenceUrl}}
            </div>
            <div class="Broadcasting__credentials-item">
              <i class="icon-ic_lock Broadcasting__credentials-icon-lock"></i>
              PIN  {{user.conferencePin}}
            </div>
          </div>
        </div>
        <div class="Broadcasting__main-actions">
          <a @click="stop"
             class="Broadcasting__main-action-btn Broadcasting__main-action-btn--red">
            stop broadcasting
          </a>
        </div>
      </div>
    </div>
    <page-title :title="'KingsConference - Broadcast'"></page-title>
  </div>
</template>

<script>
  import PageTitle from '@/components/common/page-title/page-title';

  export default {
    name: 'broadcasting-tab',
    components: {
      PageTitle
    },
    data() {
      return {
        timeNow: 0,
        interval: null,
        startedAt: Math.trunc((new Date()).getTime() / 1000)
      };
    },
    computed: {
      user() {
        return this.$store.getters.currentUser;
      },
      duration() {
        let duration = '00:00';
        const start = this.startedAt;
        if (start && start < this.timeNow) {
          const minutes = this.stringify(Math.trunc((this.timeNow - start) / 60) % 60);
          const seconds = this.stringify((this.timeNow - start) % 60);
          duration = `${minutes}:${seconds}`;
        }
        return duration;
      }
    },
    methods: {
      stop() {
        this.$store.dispatch('stopBroadcast');
      },
      stringify(n) {
        if (n.toString().length <= 1) {
          n = `0${n.toString()}`;
        }
        return n;
      }
    },
    beforeMount() {
      this.interval = setInterval(() => {
        this.timeNow = Math.trunc((new Date()).getTime() / 1000);
      }, 1000);
    },
    destroyed() {
      clearInterval(this.interval);
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// broadcasting-tab.vue?ef9b623e